(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsl-application-calendar"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    var el = root.querySelector('[data-bsl-cal]');
    if(!el || el.dataset.bslReady) return;
    el.dataset.bslReady = '1';
    var tabs = Array.prototype.slice.call(el.querySelectorAll('[data-bsl-cal-tab]'));
    var panels = Array.prototype.slice.call(el.querySelectorAll('[data-bsl-cal-panel]'));
    function show(i){
      tabs.forEach(function(t){ t.classList.toggle('bsl-cal__tab--active', t.getAttribute('data-bsl-cal-tab') === String(i)); });
      panels.forEach(function(p){ p.classList.toggle('bsl-cal__panel--active', p.getAttribute('data-bsl-cal-panel') === String(i)); });
    }
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){ show(tab.getAttribute('data-bsl-cal-tab')); });
    });
    el.querySelectorAll('[data-bsl-cal-next]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var current = el.querySelector('.bsl-cal__panel--active');
        var i = current ? parseInt(current.getAttribute('data-bsl-cal-panel'),10) : 0;
        show((i + 1) % panels.length);
      });
    });
  }
  function init(root){ setup(root || document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-contact-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    var el = root.querySelector('[data-bsl-contact]');
    if(!el || el.dataset.bslReady) return;
    el.dataset.bslReady = '1';
    var data = [];
    try { data = JSON.parse(el.querySelector('[data-bsl-contact-data]').textContent) || []; } catch(e){ data = []; }
    el.querySelectorAll('[data-bsl-topic]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var t = data[parseInt(btn.getAttribute('data-bsl-topic'),10)];
        if(!t) return;
        el.querySelectorAll('[data-bsl-topic]').forEach(function(b){ b.classList.toggle('bsl-cm__topic--active', b === btn); });
        var note = el.querySelector('[data-bsl-topic-note]'); if(note) note.textContent = t.note || '';
        var fl = el.querySelector('[data-bsl-field-label]'); if(fl) fl.textContent = t.field_label || '';
        var fi = el.querySelector('[data-bsl-field-input]'); if(fi) fi.setAttribute('placeholder', t.field_placeholder || '');
        var mi = el.querySelector('[data-bsl-message-input]'); if(mi) mi.setAttribute('placeholder', t.message_placeholder || '');
        var ti = el.querySelector('[data-bsl-topic-input]'); if(ti) ti.value = t.label || '';
        var wa = el.querySelector('[data-bsl-wa-link]'); if(wa && t.wa) wa.setAttribute('href', t.wa);
      });
    });
  }
  function init(root){ setup(root || document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    var list = root.querySelector('[data-bsl-faq]');
    if(!list || list.dataset.bslReady) return;
    list.dataset.bslReady = '1';
    list.querySelectorAll('[data-bsl-faq-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var panel = btn.parentElement.querySelector('[data-bsl-faq-panel]');
        var open = btn.getAttribute('aria-expanded') === 'true';
        list.querySelectorAll('[data-bsl-faq-toggle]').forEach(function(b){
          b.setAttribute('aria-expanded','false');
          var p = b.parentElement.querySelector('[data-bsl-faq-panel]');
          if(p) p.hidden = true;
        });
        if(!open){ btn.setAttribute('aria-expanded','true'); if(panel) panel.hidden = false; }
      });
    });
  }
  function init(root){ setup(root || document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-product-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    var el = root.querySelector('.bsl-pp');
    if(!el || el.dataset.bslReady) return;
    el.dataset.bslReady = '1';

    var heroImg = el.querySelector('[data-bsl-pp-heroimg]');
    el.querySelectorAll('[data-bsl-pp-thumb]').forEach(function(btn){
      btn.addEventListener('click', function(){
        el.querySelectorAll('[data-bsl-pp-thumb]').forEach(function(b){ b.classList.toggle('bsl-pp__thumb--active', b === btn); });
        if(heroImg) heroImg.src = btn.getAttribute('data-bsl-pp-thumb');
      });
    });

    var variantInput = el.querySelector('[data-bsl-pp-variantinput]');
    var priceEl = el.querySelector('[data-bsl-pp-price]');
    var stockEl = el.querySelector('[data-bsl-pp-stock]');
    var submitBtn = el.querySelector('[data-bsl-pp-submit]');
    var formBadge = el.querySelector('[data-bsl-pp-formbadge]');
    el.querySelectorAll('[data-bsl-pp-size]').forEach(function(btn){
      btn.addEventListener('click', function(){
        el.querySelectorAll('[data-bsl-pp-size]').forEach(function(b){ b.classList.toggle('bsl-pp__size--active', b === btn); });
        if(variantInput) variantInput.value = btn.getAttribute('data-variant-id');
        if(priceEl) priceEl.textContent = btn.getAttribute('data-price');
        if(formBadge) formBadge.textContent = btn.getAttribute('data-variant-title');
        var available = btn.getAttribute('data-available') === 'true';
        if(stockEl){
          stockEl.style.setProperty('--stock-color', available ? 'var(--bsl-green-600,#256B38)' : 'var(--bsl-text-muted,#5E6B62)');
          stockEl.lastChild.textContent = available ? 'In stock' : 'Sold out';
        }
        if(submitBtn){
          submitBtn.disabled = !available;
          submitBtn.textContent = available ? 'Add to cart' : 'Sold out, notify me';
        }
        if(variantInput) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    var qtyInput = el.querySelector('[data-bsl-pp-qty]');
    var dec = el.querySelector('[data-bsl-pp-dec]');
    var inc = el.querySelector('[data-bsl-pp-inc]');
    if(dec && qtyInput) dec.addEventListener('click', function(){ qtyInput.value = Math.max(1, (parseInt(qtyInput.value,10)||1) - 1); });
    if(inc && qtyInput) inc.addEventListener('click', function(){ qtyInput.value = (parseInt(qtyInput.value,10)||1) + 1; });

    var tabsWrap = el.querySelector('[data-bsl-pp-tabs]');
    if(tabsWrap){
      tabsWrap.querySelectorAll('[data-bsl-pp-tab]').forEach(function(tab){
        tab.addEventListener('click', function(){
          var id = tab.getAttribute('data-bsl-pp-tab');
          tabsWrap.querySelectorAll('[data-bsl-pp-tab]').forEach(function(t){ t.classList.toggle('bsl-pp__tab--active', t === tab); });
          tabsWrap.querySelectorAll('[data-bsl-pp-panel]').forEach(function(p){ p.classList.toggle('bsl-pp__panel--active', p.getAttribute('data-bsl-pp-panel') === id); });
        });
      });
    }

    var faqWrap = el.querySelector('[data-bsl-pp-faq]');
    if(faqWrap){
      faqWrap.querySelectorAll('[data-bsl-pp-faqtoggle]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var panel = btn.parentElement.querySelector('.bsl-pp__faqa');
          var open = btn.getAttribute('aria-expanded') === 'true';
          faqWrap.querySelectorAll('[data-bsl-pp-faqtoggle]').forEach(function(b){
            b.setAttribute('aria-expanded','false');
            var p = b.parentElement.querySelector('.bsl-pp__faqa');
            if(p) p.hidden = true;
          });
          if(!open){ btn.setAttribute('aria-expanded','true'); if(panel) panel.hidden = false; }
        });
      });
    }
  }
  function init(root){ setup(root || document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-products-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    var el = root.querySelector('[data-bsl-pg]');
    if(!el || el.dataset.bslReady) return;
    el.dataset.bslReady = '1';
    var section = el.closest('.bsl-pg');
    var grid = section.querySelector('[data-bsl-pg-grid]');
    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-bsl-pg-type]'));
    var countEl = section.querySelector('[data-bsl-pg-count]');
    var currentFilter = 'all';
    var sortModes = ['Featured', 'Price, low to high', 'Price, high to low'];
    var sortIndex = 0;

    function apply(){
      var visible = 0;
      tiles.forEach(function(t){
        var show = currentFilter === 'all' || t.getAttribute('data-bsl-pg-type') === currentFilter;
        t.hidden = !show;
        if(show) visible++;
      });
      if(countEl) countEl.textContent = 'Showing ' + visible + ' of ' + tiles.length + ' products';
    }
    function sortTiles(){
      var mode = sortModes[sortIndex];
      if(mode === 'Featured') return;
      var sorted = tiles.slice().sort(function(a,b){
        var pa = parseFloat(a.getAttribute('data-bsl-pg-price')) || 0;
        var pb = parseFloat(b.getAttribute('data-bsl-pg-price')) || 0;
        return mode === 'Price, low to high' ? pa - pb : pb - pa;
      });
      sorted.forEach(function(t){ grid.appendChild(t); });
    }

    el.querySelectorAll('[data-bsl-pg-filter]').forEach(function(btn){
      btn.addEventListener('click', function(){
        currentFilter = btn.getAttribute('data-bsl-pg-filter');
        el.querySelectorAll('[data-bsl-pg-filter]').forEach(function(b){ b.classList.toggle('bsl-pg__filter--active', b === btn); });
        apply();
      });
    });
    var sortBtn = el.querySelector('[data-bsl-pg-sort]');
    if(sortBtn){
      sortBtn.addEventListener('click', function(){
        sortIndex = (sortIndex + 1) % sortModes.length;
        sortBtn.childNodes[0].textContent = sortModes[sortIndex] + ' ';
        sortTiles();
      });
    }
    apply();
  }
  function init(root){ setup(root || document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-programme-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    var el = root.querySelector('[data-bsl-finder]');
    if(!el || el.dataset.bslReady) return;
    el.dataset.bslReady = '1';
    var data = [];
    try { data = JSON.parse(el.querySelector('[data-bsl-finder-data]').textContent) || []; } catch(e){ data = []; }
    var steps = { 1: el.querySelector('[data-bsl-step="1"]'), 2: el.querySelector('[data-bsl-step="2"]'), 3: el.querySelector('[data-bsl-step="3"]') };
    var bar = el.querySelector('[data-bsl-bar]');
    var state = { scope: null, goal: null };

    function show(n){
      [1,2,3].forEach(function(i){ if(steps[i]) steps[i].hidden = (i !== n); });
      if(bar) bar.style.width = n === 1 ? '8%' : (n === 2 ? '55%' : '100%');
    }
    function txt(sel, value){ var t = el.querySelector(sel); if(t) t.textContent = value || ''; }

    function result(){
      var goal = data[state.goal];
      if(!goal) return;
      var branch = goal[state.scope] || {};
      var p = branch.primary;
      if(!p || !p.title){ show(1); return; }
      var img = el.querySelector('[data-bsl-rec-img]');
      if(img){ img.src = p.img || ''; img.alt = p.title; }
      txt('[data-bsl-rec-name]', p.title);
      txt('[data-bsl-rec-note]', goal.note || '');
      txt('[data-bsl-rec-price]', p.available ? ('From ' + p.price) : 'Currently out of stock');
      var link = el.querySelector('[data-bsl-rec-link]');
      if(link) link.setAttribute('href', p.url || '#');
      txt('[data-bsl-rec-cta]', (p.available ? 'Shop ' : 'View ') + p.title);
      var wrap = el.querySelector('[data-bsl-partner]');
      var pa = branch.partner;
      if(wrap){
        if(pa && pa.title && pa.available){
          wrap.hidden = false;
          var pimg = el.querySelector('[data-bsl-partner-img]');
          if(pimg){ pimg.src = pa.img || ''; pimg.alt = pa.title; }
          txt('[data-bsl-partner-name]', pa.title);
          txt('[data-bsl-partner-price]', 'From ' + pa.price);
          var plink = el.querySelector('[data-bsl-partner-link]');
          if(plink) plink.setAttribute('href', pa.url || '#');
        } else { wrap.hidden = true; }
      }
      show(3);
    }

    el.querySelectorAll('[data-bsl-scope]').forEach(function(b){
      b.addEventListener('click', function(){ state.scope = b.getAttribute('data-bsl-scope'); state.goal = null; show(2); });
    });
    el.querySelectorAll('[data-bsl-goal]').forEach(function(b){
      b.addEventListener('click', function(){ state.goal = parseInt(b.getAttribute('data-bsl-goal'),10); result(); });
    });
    el.querySelectorAll('[data-bsl-restart]').forEach(function(b){
      b.addEventListener('click', function(){ state = { scope:null, goal:null }; show(1); });
    });
    show(1);
  }
  function init(root){ setup(root || document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-sampling-steps"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    var el = root.querySelector('[data-bsl-samp]');
    if(!el || el.dataset.bslReady) return;
    el.dataset.bslReady = '1';
    var section = el.closest('.bsl-samp');
    el.querySelectorAll('[data-bsl-samp-tab]').forEach(function(tab){
      tab.addEventListener('click', function(){
        var i = tab.getAttribute('data-bsl-samp-tab');
        el.querySelectorAll('[data-bsl-samp-tab]').forEach(function(t){ t.classList.toggle('bsl-samp__tab--active', t === tab); });
        section.querySelectorAll('[data-bsl-samp-panel]').forEach(function(p){ p.classList.toggle('bsl-samp__panel--active', p.getAttribute('data-bsl-samp-panel') === i); });
      });
    });
  }
  function init(root){ setup(root || document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-soil-chem-bio"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    var el = root.querySelector('[data-bsl-cb]');
    if(!el || el.dataset.bslReady) return;
    el.dataset.bslReady = '1';
    var section = el.closest('.bsl-cb');
    el.querySelectorAll('[data-bsl-cb-tab]').forEach(function(tab){
      tab.addEventListener('click', function(){
        var mode = tab.getAttribute('data-bsl-cb-tab');
        el.querySelectorAll('[data-bsl-cb-tab]').forEach(function(t){ t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
        section.querySelectorAll('[data-bsl-cb-panel]').forEach(function(p){ p.hidden = p.getAttribute('data-bsl-cb-panel') !== mode; });
        section.querySelectorAll('[data-bsl-cb-note]').forEach(function(n){ n.hidden = n.getAttribute('data-bsl-cb-note') !== mode; });
      });
    });
  }
  function init(root){ setup(root || document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    (root || document).querySelectorAll('[data-bsl-carousel]').forEach(function(el){
      if(el.dataset.bslReady) return;
      el.dataset.bslReady = '1';
      var slides = Array.prototype.slice.call(el.querySelectorAll('[data-bsl-slide]'));
      var dots = Array.prototype.slice.call(el.querySelectorAll('[data-bsl-dot]'));
      if(slides.length < 2) return;
      var i = 0, timer = null;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = el.getAttribute('data-autoplay') === 'true' && !reduce;
      function go(n){
        i = (n + slides.length) % slides.length;
        slides.forEach(function(s, k){
          var on = k === i;
          s.classList.toggle('is-active', on);
          if(on){ s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden','true'); }
        });
        dots.forEach(function(d, k){ d.classList.toggle('is-active', k === i); });
      }
      function start(){ if(auto){ stop(); timer = setInterval(function(){ go(i + 1); }, 6000); } }
      function stop(){ if(timer){ clearInterval(timer); timer = null; } }
      var prev = el.querySelector('[data-bsl-prev]');
      var next = el.querySelector('[data-bsl-next]');
      if(prev) prev.addEventListener('click', function(){ go(i - 1); start(); });
      if(next) next.addEventListener('click', function(){ go(i + 1); start(); });
      dots.forEach(function(d, k){ d.addEventListener('click', function(){ go(k); start(); }); });
      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', start);
      el.addEventListener('focusin', stop);
      el.addEventListener('focusout', start);
      go(0);
      start();
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ setup(document); }); } else { setup(document); }
  document.addEventListener('shopify:section:load', function(e){ setup(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
